import { render, staticRenderFns } from "./add-discount-voucher.vue?vue&type=template&id=227b3807"
import script from "./add-discount-voucher.vue?vue&type=script&lang=js"
export * from "./add-discount-voucher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports